import { render, staticRenderFns } from "./compliance-registration-notification.vue?vue&type=template&id=42f653a6"
import script from "./compliance-registration-notification.vue?vue&type=script&lang=js"
export * from "./compliance-registration-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports